export default __webpack_public_path__ + "img/4f916305e565647abeb756e39dd44faf.png";